export const PORTFOLIO_ITEMS = [
  { // ID : 0
    id: 'portfolio-0-3d-ecommerce',
    href: "https://threed-e-commerce.onrender.com",
    image: "/3D E-Comm.PNG",
    alt: "3D Ecommerce",
    title: "3D Ecommerce",
    forSale: true
  },
  { // ID : 1
    id: 'port Dr. Ibrahim Mansour ',
    href: "https://dr-brahim-mansour.netlify.app/",
    image: "/Dr_ibrahim.PNG",
    alt: "Availebel",
    title: "Dr. Ibrahim Mansour",
    forSale: true
  },
  { // ID : 2
    id: 'Maitre Karim Benali',
    href: "https://maitre-karim-benali.netlify.app/",
    image: "/Mtr_Karim_Benali.jpg",
    alt: "Nexit Brand Identity",
    title: "Maître Karim Benali",
    forSale: true
  },
  { // ID : 3
    id: 'Aurelio Vance',
    href: "https://aurelio-vance-luxury-design.netlify.app/",
    image: "/Aurelio_Vance0.1.PNG",
    alt: "Luxery Designe",
    title: "Aurelio Vance",
    forSale: true
  },
  { // ID : 4
    id: 'portfolio-4-available',
    href: "https://flawless-2pqq.onrender.com",
    image: "/Flaw.PNG",
    alt: "Flaw",
    title: "Available",
    forSale: true
  },
  { // ID : 5
    id: 'portfolio-5-professional-portfolio',
    href: "https://creative-website-jumper.onrender.com",
    image: "/P1.PNG",
    alt: "Nexit Brand Identity",
    title: "Professional Portfolio",
    forSale: true
  },
  { // ID : 6
    id: 'portfolio-6-experience-digital-banking-with-ai',
    href: "https://hoobank-neon-future.onrender.com",
    image: "/HooBank.png",
    alt: "Business Web UI",
    title: "Experience digital banking with AI ",
    forSale: true
  } ,
    { // ID : 7
    id: 'portfolio-7-will-be-deployed-soon',
    href: "#",
    image: "/ex5.png",
    alt: "Will be deployed soon.",
    title: "Will be deployed soon.",
    forSale: false
  }
];
